export default {
  defaultVariableText: 'Select variable',
  parameter: 'variable',
  emptyRegexp: 'Fill in the value of n',
  emptyVariableText: 'String of characters',
};
